module.exports = __webpack_public_path__ + "static/img/A61831_2.e68d8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61831_2.png
// module id = tvH5
// module chunks = 1